/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Belief_Body_3Inputs */

const en_about_belief_body_3 = /** @type {(inputs: About_Belief_Body_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI is part of the system. The connections, rules and everyday details are what make the whole thing useful.`)
};

const lv_about_belief_body_3 = /** @type {(inputs: About_Belief_Body_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI ir sistēmas daļa. Savienojumi, noteikumi un ikdienas detaļas ir tas, kas visu kopumā padara noderīgu.`)
};

/**
* | output |
* | --- |
* | "AI is part of the system. The connections, rules and everyday details are what make the whole thing useful." |
*
* @param {About_Belief_Body_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_belief_body_3 = /** @type {((inputs?: About_Belief_Body_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Belief_Body_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_belief_body_3(inputs)
	return en_about_belief_body_3(inputs)
});